import { FunctionComponent, ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormControl, InputLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import keys from 'lodash/keys';

import localStorageService from '../../../features/shared/services/local-storage/local-storage.service';
import { castTo } from '../../../features/shared/utils/cast-to';
import { ThemeEnum } from '../../theme/enums/theme.enum';

export const ThemeSwitch: FunctionComponent = (): ReactElement => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState<ThemeEnum>(
    castTo<ThemeEnum>(localStorageService.get('themePalette')) ??
      ThemeEnum.SPARQ
  );
  const options = keys(ThemeEnum);

  return (
    <FormControl sx={{ marginTop: 5 }}>
      <InputLabel id="theme-switch">Theme Switch</InputLabel>
      <Select
        value={selectedItem}
        data-testid="theme-switch-select"
        labelId="theme-switch"
        label="Theme Switch"
        sx={{ width: 250 }}
        onChange={event => {
          const currentThemeName = event.target.value as ThemeEnum;
          localStorageService.set('themePalette', currentThemeName);
          setSelectedItem(currentThemeName);
          navigate(0);
        }}
        inputProps={{
          id: 'theme-switch-input',
        }}
        MenuProps={{
          id: 'theme-switch-menu',
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={option}
            selected={option === selectedItem}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
